import { z } from 'zod';

export const SettlementResponseSchema = z.object({
  id: z.string().min(1),
  deal_id: z.string().min(1),
  cashflow_id: z.string().min(1),
  counterparty_id: z.string().min(1),
  payment_date: z.string(),
  amount: z.string(),
  currency: z.string(),
  direction: z.string(),
  status: z.string(),
  ssi_id: z.string().min(1).nullable(),
  external_reference: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type SettlementResponse = z.infer<typeof SettlementResponseSchema>;

export const SettlementListFiltersSchema = z.object({
  dealId: z.string().optional(),
  status: z.string().optional(),
  counterpartyId: z.string().optional(),
});

export type SettlementListFilters = z.infer<typeof SettlementListFiltersSchema>;

export const SettlementListViewSchema = z.enum(['operational', 'all']);

export type SettlementListView = z.infer<typeof SettlementListViewSchema>;

export const SettlementListPayloadSchema = z.object({
  filters: SettlementListFiltersSchema.optional(),
  selectedSettlementIds: z.array(z.string().min(1)).optional(),
  view: SettlementListViewSchema.optional(),
});

export type SettlementListPayload = z.infer<typeof SettlementListPayloadSchema>;

export const InstructSettlementPayloadSchema = z.object({
  settlementIds: z.array(z.string().min(1)).optional(),
  settlementId: z.string().min(1).optional(),
  ssi_id: z.string().min(1).optional(),
});

export type InstructSettlementPayload = z.infer<typeof InstructSettlementPayloadSchema>;

export const InstructSettlementFormSchema = z.object({
  settlement_ids_text: z.string().min(1),
  ssi_id: z.string().min(1),
});

export type InstructSettlementForm = z.infer<typeof InstructSettlementFormSchema>;

export const InstructSettlementRequestSchema = z.object({
  ssi_id: z.string().min(1),
});

export type InstructSettlementRequest = z.infer<typeof InstructSettlementRequestSchema>;
